import { validateResponseHasSchema } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'
import { z } from 'zod'
import { invoiceSchema } from '@/features/invoices/schemas'

const client = createAssetManagementClient()

export const fetchInvoice = (id: number) => validateResponseHasSchema(
  client.sendGet(`billing/invoices/${id}?includeCustomer=true`),
  z.object({ data: invoiceSchema })
).then(
  r => r.data
)
